module.exports = __webpack_public_path__ + "static/google-reviews-91943c1bc0d5d55f6ef267db13b02340.png";